import { toastr } from 'react-redux-toastr';
import config from '../../config/config';
import { PROFILE_ACTION_TYPES, PROFILE_FIELD_NAMES } from './actionTypes';
import { authApi } from '../auth/api';
import { AUTH_ACTION_TYPES } from '../auth/actionTypes';

export const profileActions = {
    setActiveSection: (section) => ({
        type: PROFILE_ACTION_TYPES.SET_ACTIVE_SECTION,
        section,
    }),

    setProfileFields: (data) => ({
        type: PROFILE_ACTION_TYPES.SET_PROFILE_FIELDS,
        data,
    }),

    setProfileField: (fieldName, value) => ({
        type: PROFILE_ACTION_TYPES.SET_PROFILE_FIELD,
        fieldName,
        value,
    }),

    resetProfileFields: () => ({
        type: PROFILE_ACTION_TYPES.RESET_PROFILE_FIELDS,
    }),

    requestSaveProfile: () => ({
        type: PROFILE_ACTION_TYPES.REQUEST_SAVE_PROFILE,
    }),

    saveProfileSuccess: () => ({
        type: PROFILE_ACTION_TYPES.SAVE_PROFILE_SUCCESS,
    }),

    saveProfileError: (error) => ({
        type: PROFILE_ACTION_TYPES.SAVE_PROFILE_ERROR,
        error,
    }),

    requestLoadProfile: () => ({
        type: PROFILE_ACTION_TYPES.REQUEST_LOAD_PROFILE,
    }),

    loadProfileSuccess: (data) => ({
        type: PROFILE_ACTION_TYPES.LOAD_PROFILE_SUCCESS,
        data,
    }),

    loadProfileError: (error) => ({
        type: PROFILE_ACTION_TYPES.LOAD_PROFILE_ERROR,
        error,
    }),

    requestChangePassword: () => ({
        type: PROFILE_ACTION_TYPES.REQUEST_CHANGE_PASSWORD,
    }),

    changePasswordSuccess: () => ({
        type: PROFILE_ACTION_TYPES.CHANGE_PASSWORD_SUCCESS,
    }),

    changePasswordError: (error) => ({
        type: PROFILE_ACTION_TYPES.CHANGE_PASSWORD_ERROR,
        error,
    }),

    requestOrders: () => ({
        type: PROFILE_ACTION_TYPES.REQUEST_ORDERS,
    }),

    receiveOrders: (data, pagination) => ({
        type: PROFILE_ACTION_TYPES.RECEIVE_ORDERS,
        data,
        pagination,
    }),

    ordersError: (error) => ({
        type: PROFILE_ACTION_TYPES.ORDERS_ERROR,
        error,
    }),

    requestServices: () => ({
        type: PROFILE_ACTION_TYPES.REQUEST_SERVICES,
    }),

    receiveServices: (data, pagination) => ({
        type: PROFILE_ACTION_TYPES.RECEIVE_SERVICES,
        data,
        pagination,
    }),

    servicesError: (error) => ({
        type: PROFILE_ACTION_TYPES.SERVICES_ERROR,
        error,
    }),

    requestDocuments: () => ({
        type: PROFILE_ACTION_TYPES.REQUEST_DOCUMENTS,
    }),

    receiveDocuments: (data) => ({
        type: PROFILE_ACTION_TYPES.RECEIVE_DOCUMENTS,
        data,
    }),

    documentsError: (error) => ({
        type: PROFILE_ACTION_TYPES.DOCUMENTS_ERROR,
        error,
    }),
};


export const saveProfile = () => async (dispatch, getState) => {
    dispatch(profileActions.requestSaveProfile());

    const state = getState();
    const token = state.auth?.token;

    if (!token) {
        dispatch(profileActions.saveProfileError('Не авторизован'));
        toastr.error('Ошибка', 'Необходимо авторизоваться');
        return;
    }

    let userId = state.auth?.user?.id || state.auth?.user?.ID || state.auth?.user?.user_id;

    if (!userId) {
        try {
            const userData = await authApi.fetchUser(token);
            userId = userData?.id || userData?.ID || userData?.user_id;
            if (userData) {
                dispatch({
                    type: AUTH_ACTION_TYPES.FETCH_USER_SUCCESS,
                    payload: { user: userData },
                });
            }
        } catch (e) {
            console.error('Failed to fetch user for save:', e);
        }
    }

    if (!userId) {
        dispatch(profileActions.saveProfileError('Не удалось определить пользователя'));
        toastr.error('Ошибка', 'Не удалось определить пользователя');
        return;
    }

    const { profile } = state;
    const billingData = getFormDataForAPI(profile.fields);

    const consumerKey = process.env.REACT_APP_API_CONSUMER_KEY;
    const consumerSecret = process.env.REACT_APP_API_CONSUMER_SECRET;

    const url = `${config.API_UPDATE_USER_DATA_URL}${userId}?consumer_key=${consumerKey}&consumer_secret=${consumerSecret}`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },
            body: 'query=' + encodeURIComponent(JSON.stringify(billingData)),
        });

        const result = await response.json();

        if (!response.ok || (result.code && result.code !== 200)) {
            throw new Error(result.message || `HTTP ${response.status}`);
        }

        dispatch(profileActions.saveProfileSuccess());
        toastr.success('Успешно', result.message || 'Данные профиля сохранены');
    } catch (error) {
        console.error('Save profile error:', error);
        dispatch(profileActions.saveProfileError(error.message));
        toastr.error('Ошибка', error.message || 'Не удалось сохранить данные');
    }
};

export const loadProfile = () => async (dispatch, getState) => {
    const state = getState();
    const token = state.auth?.token;

    if (!token) {
        return;
    }

    dispatch(profileActions.requestLoadProfile());

    try {
        const userData = await authApi.fetchUser(token);
        const formattedData = setFieldsFromUserData(userData);
        dispatch(profileActions.loadProfileSuccess(formattedData));
    } catch (error) {
        console.error('Load profile error:', error);
        dispatch(profileActions.loadProfileError(error.message));
        toastr.error('Ошибка', 'Не удалось загрузить данные профиля');
    }
};

export const changePassword = (currentPassword, newPassword) => async (dispatch, getState) => {
    dispatch(profileActions.requestChangePassword());

    const token = getState().auth?.token;

    if (!token) {
        dispatch(profileActions.changePasswordError('Не авторизован'));
        toastr.error('Ошибка', 'Необходимо авторизоваться');
        return;
    }

    try {
        const response = await fetch('https://cms-store.feedtech.su/wp-json/app/v1/change-password/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ password: newPassword }),
        });

        const result = await response.json();

        if (!response.ok || (result.code && result.code !== 200)) {
            throw new Error(result.message || 'Ошибка смены пароля');
        }

        dispatch(profileActions.changePasswordSuccess());
        toastr.success('Успешно', result.message || 'Пароль изменен');
    } catch (error) {
        console.error('Change password error:', error);
        dispatch(profileActions.changePasswordError(error.message));
        toastr.error('Ошибка', error.message || 'Не удалось изменить пароль');
    }
};

export const fetchOrders = (page = 1) => async (dispatch, getState) => {
    dispatch(profileActions.requestOrders());

    const token = getState().auth?.token;
    if (!token) return;

    try {
        const url = `${config.API_CUSTOMER_ORDERS_URL}?page=${page}`;
        const response = await fetch(url, {
            headers: { Authorization: 'Bearer ' + token },
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || `HTTP ${response.status}`);
        }

        const orders = Array.isArray(result) ? result : (result.data || []);
        const pagination = {
            total: result.total || orders.length,
            totalPages: result.total_pages || 1,
            page: result.page || page,
            perPage: result.per_page || 10,
        };
        dispatch(profileActions.receiveOrders(orders, pagination));
    } catch (error) {
        console.error('Fetch orders error:', error);
        dispatch(profileActions.ordersError(error.message));
        toastr.error('Ошибка', 'Не удалось загрузить заказы');
    }
};

export const fetchServices = (page = 1) => async (dispatch, getState) => {
    dispatch(profileActions.requestServices());

    const token = getState().auth?.token;
    if (!token) return;

    try {
        const url = `${config.API_CUSTOMER_SERVICES_URL}?page=${page}`;
        const response = await fetch(url, {
            headers: { Authorization: 'Bearer ' + token },
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || `HTTP ${response.status}`);
        }

        const services = Array.isArray(result) ? result : (result.data || []);
        const pagination = {
            total: result.total || services.length,
            totalPages: result.total_pages || 1,
            page: result.page || page,
            perPage: result.per_page || 10,
        };
        dispatch(profileActions.receiveServices(services, pagination));
    } catch (error) {
        console.error('Fetch services error:', error);
        dispatch(profileActions.servicesError(error.message));
        toastr.error('Ошибка', 'Не удалось загрузить услуги');
    }
};

export const fetchDocuments = () => (dispatch) => {
    dispatch(profileActions.requestDocuments());

    return new Promise((resolve) => {
        setTimeout(() => {
            dispatch(profileActions.receiveDocuments([]));
            resolve();
        }, 300);
    });
};

export const getFormDataForAPI = (fields) => {
    const isJuridic = fields[PROFILE_FIELD_NAMES.IS_JURIDIC];

    const data = {
        first_name: fields[PROFILE_FIELD_NAMES.FIRSTNAME] || '',
        last_name: fields[PROFILE_FIELD_NAMES.LASTNAME] || '',
        email: fields[PROFILE_FIELD_NAMES.EMAIL] || '',
        phone: fields[PROFILE_FIELD_NAMES.PHONE] || '',
        phone_country: fields[PROFILE_FIELD_NAMES.PHONE_COUNTRY] || 'RU',
        country: fields[PROFILE_FIELD_NAMES.COUNTRY] || '',
        state: fields[PROFILE_FIELD_NAMES.REGION] || '',
        city: fields[PROFILE_FIELD_NAMES.CITY] || '',
        postcode: fields[PROFILE_FIELD_NAMES.POSTAL_CODE] || '',
        is_juridic: isJuridic ? 'true' : 'false',
    };

    if (isJuridic) {
        data.company = fields[PROFILE_FIELD_NAMES.COMPANY] || '';
        data.company_inn = fields[PROFILE_FIELD_NAMES.COMPANY_INN] || '';
        data.company_kpp = fields[PROFILE_FIELD_NAMES.COMPANY_KPP] || '';
        data.company_ogrn = fields[PROFILE_FIELD_NAMES.COMPANY_OGRN] || '';
        data.company_chief_name = fields[PROFILE_FIELD_NAMES.COMPANY_CHIEF_NAME] || '';
        data.company_job_title = fields[PROFILE_FIELD_NAMES.COMPANY_JOB_TITLE] || '';
        data.company_scope = fields[PROFILE_FIELD_NAMES.COMPANY_SCOPE] || '';
        data.company_law_address = fields[PROFILE_FIELD_NAMES.COMPANY_LEGAL_ADDR] || '';
        data.company_post_address = fields[PROFILE_FIELD_NAMES.COMPANY_POST_ADDR] || '';
    }

    return { billing: data };
};

export const setFieldsFromAPIData = (apiData) => setFieldsFromUserData(apiData);

export const setFieldsFromUserData = (userData) => {
    const billing = userData?.billing || {};
    const d = { ...billing, ...userData };

    return {
        [PROFILE_FIELD_NAMES.LOGIN]: d.username || d.login || '',
        [PROFILE_FIELD_NAMES.DISPLAY_NAME]: d.display_name || `${d.first_name || ''} ${d.last_name || ''}`.trim(),

        [PROFILE_FIELD_NAMES.COUNTRY]: d.country || 'RU',
        [PROFILE_FIELD_NAMES.REGION]: d.state || '',
        [PROFILE_FIELD_NAMES.CITY]: d.city || '',
        [PROFILE_FIELD_NAMES.POSTAL_CODE]: d.postcode || '',
        [PROFILE_FIELD_NAMES.ADDRESS]: d.address_1 || '',

        [PROFILE_FIELD_NAMES.FIRSTNAME]: d.first_name || '',
        [PROFILE_FIELD_NAMES.LASTNAME]: d.last_name || '',
        [PROFILE_FIELD_NAMES.PHONE_COUNTRY]: d.phone_country || 'RU',
        [PROFILE_FIELD_NAMES.PHONE]: d.phone || '',
        [PROFILE_FIELD_NAMES.EMAIL]: d.email || '',

        [PROFILE_FIELD_NAMES.IS_JURIDIC]: d.is_juridic === true || d.is_juridic === 'true',
        [PROFILE_FIELD_NAMES.COMPANY]: d.company || '',
        [PROFILE_FIELD_NAMES.COMPANY_INN]: d.company_inn || '',
        [PROFILE_FIELD_NAMES.COMPANY_KPP]: d.company_kpp || '',
        [PROFILE_FIELD_NAMES.COMPANY_OGRN]: d.company_ogrn || '',
        [PROFILE_FIELD_NAMES.COMPANY_CHIEF_NAME]: d.company_chief_name || '',
        [PROFILE_FIELD_NAMES.COMPANY_CONTACT_NAME]: d.company_contact_name || '',
        [PROFILE_FIELD_NAMES.COMPANY_JOB_TITLE]: d.company_job_title || '',
        [PROFILE_FIELD_NAMES.COMPANY_SCOPE]: d.company_scope || '',
        [PROFILE_FIELD_NAMES.COMPANY_LEGAL_ADDR]: d.company_law_address || '',
        [PROFILE_FIELD_NAMES.COMPANY_POST_ADDR]: d.company_post_address || '',
    };
};
